// entry point for providing a version without webpack

import * as snoop from './index'
import './scss/cookie-consent-scoped.scss'


window.snoopCookieConsent = snoop
